import { API_URL } from '../../constants';
import { getDispatch } from '../../../spa/store';
import { postRequest } from '../../utils/requestService';

export class ErrorRest {

  private static LOG_URL = API_URL + '/error/log';

  public static async log(text: string): Promise<any> {
    const dispatch = getDispatch();
    return await dispatch(postRequest(this.LOG_URL, {text}));
  }
}
